import React from 'react';
import {settingsText} from '../../settingsText';
import Button from '../../../../uiToolkit/Buttons/Button';
import {numberWithCommas} from '../../../../utils/getFirstCapitals';

interface Props {
  onBuyAddons: () => void;
  creditsAvailable: number;
  disabled?: boolean;
}

const AiCreditsCard = React.memo(
  ({onBuyAddons, creditsAvailable, disabled}: Props) => {
    return (
      <div className="DashboardCard AiCredits">
        <p className="Title">{settingsText.aiActionsUsed}</p>
        <div className="CardCenteredBody">
          <span className="AvailableBalance">
            {settingsText.avaialbleBalance}
          </span>
          <h3 className="AiCredits">
            {numberWithCommas(creditsAvailable.toString())}
          </h3>
        </div>
        <div className="d-flex flex-row justify-content-center">
          <Button
            uiType="hollow"
            title={settingsText.upgradeForMoreActions}
            onClick={onBuyAddons}
            icon="icon-icon_plus_circle"
            disabled={disabled}
            tooltip={
              disabled ? settingsText.notAvailableForTrialPlan : undefined
            }
          />
        </div>
      </div>
    );
  },
);

export default AiCreditsCard;
